import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaShieldAlt, FaHome, FaArrowLeft } from 'react-icons/fa';

export default function Unauthorized() {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-900 via-indigo-900 to-blue-900 flex items-center justify-center px-4">
            <div className="max-w-md w-full bg-white/10 backdrop-blur-xl border border-white/20 p-8 rounded-3xl shadow-2xl text-center">
                <div className="mb-6 flex justify-center">
                    <div className="w-20 h-20 bg-amber-500/20 rounded-full flex items-center justify-center">
                        <FaShieldAlt className="text-4xl text-amber-400" />
                    </div>
                </div>

                <h1 className="text-4xl font-bold text-white mb-2">Access Denied</h1>
                <p className="text-blue-100/70 mb-8">
                    You don't have permission to access this page. Please contact your administrator if you believe this is an error.
                </p>

                <div className="flex flex-col gap-3">
                    <button
                        onClick={() => navigate('/dashboard')}
                        className="w-full py-3 bg-white text-blue-900 rounded-xl font-bold hover:bg-blue-50 transition-all shadow-lg"
                    >
                        Go to Dashboard
                    </button>
                    <button
                        onClick={() => navigate(-1)}
                        className="w-full py-3 bg-white/5 border border-white/10 text-white rounded-xl font-bold hover:bg-white/10 transition-all"
                    >
                        Go Back
                    </button>
                </div>
            </div>
        </div>
    );
}
